import { AverageRating } from '../projectsOverview/projectsOverviewStore.types';

export interface Indicators {
  status: string;
  value: string;
}

export interface Picture {
  imageSrc: string;
  imageAlt: string;
}
export interface ProjectDataStoreType {
  projectDetails: {
    id: string;
    projectName: string;
    country: string;
    sector: string;
    sector2: string;
    carrierType: string;
    year: number;
    investment?: number;
    sourceOfFounds: string;
    projectNumber: number;
    reportUrl: string;
    description: string;
    lessonsLearnt: string[];
    picture?: Picture;
    rating: AverageRating;
    outcome: { indicators: Indicators[]; targets: string[] };
    impacts: { indicators: Indicators[]; targets: string[] };
  };
  randomProjects: Array<{
    id: string;
    titel: string;
    photo?: Picture;
  }>;
  errorProjectDetails: boolean;
  errorRandomProjects: boolean;
}

export enum ProjectDataStoreKind {
  UPDATE_PROJECT_DETAILS = 'UPDATE_PROJECT_DETAILS',
  UPDATE_RANDOM_PROJECTS = 'UPDATE_RANDOM_PROJECTS',
  UPDATE_PROJECT_DETAILS_ERROR = 'UPDATE_PROJECT_DETAILS_ERROR',
  UPDATE_RANDOM_PROJECTS_DETAILS_ERROR = 'UPDATE_RANDOM_PROJECTS_DETAILS_ERROR',
}

export type ProjectDataStoreAction =
  | {
      type: ProjectDataStoreKind.UPDATE_PROJECT_DETAILS;
      payload: ProjectDataStoreType['projectDetails'];
    }
  | {
      type: ProjectDataStoreKind.UPDATE_RANDOM_PROJECTS;
      payload: ProjectDataStoreType['randomProjects'];
    }
  | {
      type: ProjectDataStoreKind.UPDATE_PROJECT_DETAILS_ERROR;
      payload: boolean;
    }
  | {
      type: ProjectDataStoreKind.UPDATE_RANDOM_PROJECTS_DETAILS_ERROR;
    };
